module.exports = new __parcel__URL__("plans-roadmap.8440d94d.svg").toString();